/* eslint-disable quotes, quote-props, comma-dangle  */
import type { TranslationProps } from './types';

export const translations = {
  "cancel_button_label": [
    {
      "type": 0,
      "value": "Abbrechen"
    }
  ],
  "warning_body_list_item_one": [
    {
      "type": 0,
      "value": "Sie haben eine geschäftliche Rechtfertigung für den Zugriff auf Kundendaten erhalten"
    }
  ],
  "warning_body_list_item_two": [
    {
      "type": 0,
      "value": "Ihre Download-Aktivitäten werden zu Sicherheitszwecken aufgezeichnet und nachverfolgt"
    }
  ],
  "warning_footer": [
    {
      "type": 0,
      "value": "Möchten Sie fortfahren?"
    }
  ],
  "warning_header": [
    {
      "type": 0,
      "value": "Durch das Herunterladen bestätigen Sie, dass:"
    }
  ]
};

function TranslationProviderComponent({ children }: TranslationProps) {
  return children(translations);
}

export default Object.assign(TranslationProviderComponent, { translations });
